import React, { CSSProperties } from "react";
import { Circles } from "react-loader-spinner";
import { useSelector } from "react-redux";

const styles = {
  loaderContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1400,
  } as CSSProperties,
};

export default function Loader() {
  const LoaderSelector = useSelector((state: any) => state.loaderReducer);
  const { LoaderOpened } = LoaderSelector;

  return (
    <>
      {LoaderOpened ? (
        <div style={styles.loaderContainer}>
          <Circles color="#8AD0C6" height={50} width={50} />
        </div>
      ) : null}
    </>
  );
}
